import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
//import { debug } from 'console';
import { first } from 'rxjs/operators';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, ServiceStatus, SUConfirmArrival } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { MeasurementEstimateFeesComponent } from '../measurement-Estimate-fees/measurement-Estimate-fees-component';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';
import { ConfirmTransitComponent } from '../confirm-transit/confirm-transit-component';


@Component({
  selector: 'app-Ism-confirm-Arrival',
  templateUrl: './ism-confirm-arrival.component.html'
})

export class IsmConfirmArrivalComponent  implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  decision = SUConfirmArrival;
  decisionKeys = Object.keys(this.decision);
  decisionValue: number;
  displayedLang: string;
  public ismConfirmArrivalForm: FormGroup;
  user: User = new User();
  showRequest = false;
  ISMConfirmArrivalObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  smallUnitRequestDTO: SmallUnitRequest = new SmallUnitRequest();
  agentId: string;
  responseObj: ResponseObject = new ResponseObject();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  isLoaded: boolean = false;
  @Input() public isShow: boolean = true;
  @ViewChild('ConfirmTransit',{static: false}) ConfirmTransit: ConfirmTransitComponent;
  public disableForm: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private translate: TranslateService,
    private suServ: SmallUnitsServiceFE, private suAdminServ: SmallUnitsAdminService) {
    this.isShow = true;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.user = this.globalSrv.user;

  }

  ngOnInit(): void {
    this.buildForm(null);
  }
  buildForm(decision) {
    this.ismConfirmArrivalForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
      ISMNotes:['', [Validators.required]]
    });
    if (decision == SUConfirmArrival.Arrived) {
      this.ismConfirmArrivalForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        ISMActualArrivalTime: ['', [Validators.required]],
        ISMNotes:['', [Validators.required]]
      });
    }
    if (decision == SUConfirmArrival.Cancelled) {
      this.ismConfirmArrivalForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        ISMNotes:['', [Validators.required]]
      });
    }
  }
  get f() {
    return this.ismConfirmArrivalForm.controls;
  }
  changeDecision(value) {
    this.buildForm(value);
    this.ismConfirmArrivalForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }
  getBaseRequest() {
    this.suServ.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {

          this.smallUnitRequestDTO = this.responseObj.Data;
          this.requestStatus = this.smallUnitRequestDTO.StatusId;
          this.agentId = this.smallUnitRequestDTO.RequestorId;
          this.isLoaded = true;
          // check if component open fron request history
          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
            //to view "more information" data in case Measurement officer require it from agent and penending agent update
            //or after agent update request and pending Measurement officer approval
            if (this.smallUnitRequestDTO.ISMActionId == SUConfirmArrival.Arrived) {
              this.decisionValue = this.smallUnitRequestDTO.ISMActionId;
              this.buildForm(this.decisionValue);
              this.ismConfirmArrivalForm.patchValue({
                Decision: this.decisionValue,
                ISMActualArrivalTime: new Date(this.smallUnitRequestDTO.ISMActualArrivalTime),
                ISMNotes: this.smallUnitRequestDTO.ISMNotes,

              });
            } else if (this.smallUnitRequestDTO.ISMActionId == SUConfirmArrival.Cancelled) {
              this.decisionValue = this.smallUnitRequestDTO.ISMActionId;
              this.buildForm(this.decisionValue);
              this.ismConfirmArrivalForm.patchValue({
                Decision: this.decisionValue,
               ISMNotes: this.smallUnitRequestDTO.ISMNotes,
              });
            }
            this.ismConfirmArrivalForm.disable();
            // this.disableForm=true;
            this.ismConfirmArrivalForm.controls.Decision.disable();
          } else if (this.requestStatus == ServiceStatus.SmallUnit_PendingISMUnitArrival_PendingFinalFees) {
            this.formMode = FormMode.Add;
            this.ismConfirmArrivalForm.enable();
          } else {
            this.decisionValue = SUConfirmArrival.Arrived;
            this.buildForm(this.decisionValue);
            this.changeDecision(this.decisionValue);
            this.ismConfirmArrivalForm.patchValue({
              Decision: SUConfirmArrival.Arrived,
              ISMActualArrivalTime: new Date(this.smallUnitRequestDTO.ISMActualArrivalTime),
              ISMNotes: this.smallUnitRequestDTO.ISMNotes
            });
            // to hide submit button
            this.formMode = FormMode.Readonly;
            this.ismConfirmArrivalForm.disable();
          }

        }
      }

    )
  }
  ActualArrivalTimeChanged(event) {

    // if (event.target.value == "Invalid Date" || new Date(event.target.value) < new Date()) {
    if (event.target.value == "Invalid Date") {
      this.ismConfirmArrivalForm.controls['ISMActualArrivalTime'].setErrors({ 'invalid': true });
    } else if (this.ismConfirmArrivalForm.get("ISMActualArrivalTime").value){
      var ActualArrivalTime = this.ismConfirmArrivalForm.get("ISMActualArrivalTime").value.toLocaleString('en-US');
      this.ismConfirmArrivalForm.controls['ISMActualArrivalTime'].setValue(ActualArrivalTime);
    }
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.ismConfirmArrivalForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    if (this.ismConfirmArrivalForm.get("ISMActualArrivalTime") != null && this.ismConfirmArrivalForm.get("ISMActualArrivalTime").value) {
      var ActualArrivalTime = this.ismConfirmArrivalForm.get("ISMActualArrivalTime").value.toLocaleString('en-US');
      this.ismConfirmArrivalForm.controls['ISMActualArrivalTime'].setValue(ActualArrivalTime);
    }
    this.ISMConfirmArrivalObject = this.ismConfirmArrivalForm.value;

    this.ISMConfirmArrivalObject.AdminEmail = this.user.UserName;
    this.ISMConfirmArrivalObject.Id = this.baseRequestId;
    this.ISMConfirmArrivalObject.ISMActionId = this.decisionValue;
    this.suAdminServ.AddIsmConfirmArrivalDecision(this.ISMConfirmArrivalObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.ismConfirmArrivalForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
